import {
  DeviceLoginIntentURL,
  IntentURL,
  InvalidIntentURLError,
  UserLoginIntentURL,
} from '@/classes/IntentURL'
import { useAuthStore } from '@/stores/AuthStore'
import router from '@/router'
import presentToast from '@/composables/useToasts'
import { i18n } from '@/locales/locales'

const { t } = i18n
const handleAppUrlOpen = async (url: URL) => {
  let intentUrl: IntentURL

  try {
    intentUrl = IntentURL.parse(url)
  } catch (error) {
    if (error instanceof InvalidIntentURLError) {
      void presentToast({
        message: t('phrases.wrong_code_text_short'),
        color: 'danger',
      })
    }
    throw error
  }

  if (
    intentUrl instanceof UserLoginIntentURL ||
    intentUrl instanceof DeviceLoginIntentURL
  ) {
    if (useAuthStore().deviceIsAuthenticated) {
      void presentToast({
        message: t('phrases.code_already_connected'),
        color: 'danger',
      })
      throw new Error('already connected')
    }

    return router.push({
      name: 'codeAuth',
      replace: router.currentRoute.value.name === 'codeAuth',
      params: { code: intentUrl.code },
    })
  }

  throw Error('Handling for this IntentURL type not yet implemented')
}

export { handleAppUrlOpen }
